import { createContext, useContext } from 'react';
import { AccordionContextType } from './StanAccordion.types';

// Context
const AccordionContext = createContext<AccordionContextType | undefined>(undefined);

export const useAccordionContext = () => {
    const ctx = useContext(AccordionContext);
    if (!ctx) throw new Error('StanAccordionItem must be used within StanAccordion');
    return ctx;
};

interface AccordionItemContextType {
    id: string;
}
const AccordionItemContext = createContext<AccordionItemContextType | undefined>(undefined);

export const useAccordionItemContext = () => {
    const ctx = useContext(AccordionItemContext);
    if (!ctx) throw new Error('StanAccordionHeader/Body must be used within StanAccordionItem');
    return ctx;
};

export { AccordionContext, AccordionItemContext };
